import React from 'react';
import { Hero } from '../components/Hero';
import { EmotionalHook } from '../components/EmotionalHook';
import { Problem } from '../components/Problem';
import { FailedMethods } from '../components/FailedMethods';
import { Protocol } from '../components/Protocol';
import { BundleContents } from '../components/BundleContents';
import { Audience } from '../components/Audience';
import { Steps } from '../components/Steps';
import { FAQ } from '../components/FAQ';
import { PriceOffer } from '../components/PriceOffer';
import { Divider } from '../components/ui/Divider';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-body text-warmBrown-900 overflow-x-hidden" data-id="element-253">
      <Hero data-id="element-254" />
      <EmotionalHook data-id="element-255" />
      <Divider data-id="element-256" />
      <Problem data-id="element-257" />
      <FailedMethods data-id="element-258" />
      <Protocol data-id="element-259" />
      <BundleContents data-id="element-260" />
      <Audience data-id="element-261" />
      <Steps data-id="element-262" />
      <Divider data-id="element-263" />
      <FAQ data-id="element-264" />
      <PriceOffer data-id="element-265" />
      <Footer data-id="element-266" />
    </div>;
}